import store from "@/store";
export default {
  getBookables(tenant, populate) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return ApiClient.get(`api/${t}/bookables?populate=${populate}`);
  },
  getPublicBookables(tenant, populate) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return ApiClient.get(`api/${t}/bookables/public?populate=${populate}`);
  },
  getBookable(id, tenant, populate) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return ApiClient.get(`api/${t}/bookables/${id}?populate=${populate}`);
  },
  getPublicBookable(id, tenant, populate) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return ApiClient.get(
      `api/${t}/bookables/public/${id}?populate=${populate}`
    );
  },
  getBookablePrices(bookableId, tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return ApiClient.get(`api/${t}/bookables/${bookableId}/prices`);
  },
  async createOrUpdateBookable(bookable, tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    const formData = { ...bookable };
    formData.tenantId = t;

    // Derived from the access points on the way out, dropped on the way in:
    // sending it would claim a write permission that does not exist.
    delete formData.lockerDetails;

    // The review (glossary "Prüfstatus") is written by its own operations
    // alone (`ApiReviewService`); a save never carries it.
    delete formData.review;

    // Retired: nothing is distributed over the locker systems any more, a
    // booking gets one compartment per booked unit at each of them. A map a
    // bookable saved before that is dropped here so an old state does not
    // travel on - from a copy, because the shallow clone above still shares
    // the nested block with the caller's bookable.
    if (formData.accessPointDetails?.accessPointAmounts !== undefined) {
      formData.accessPointDetails = { ...formData.accessPointDetails };
      delete formData.accessPointDetails.accessPointAmounts;
    }

    if (formData.priceEur && typeof formData.priceEur === "string") {
      formData.priceEur = formData.priceEur.replace(",", ".");
      formData.priceEur = Number(formData.priceEur);
    }

    if (
      formData.priceValueAddedTax &&
      typeof formData.priceValueAddedTax === "string"
    ) {
      formData.priceValueAddedTax = formData.priceValueAddedTax.replace(
        ",",
        "."
      );
      formData.priceValueAddedTax = Number(formData.priceValueAddedTax);
    }

    formData.specialOpeningHours = formData.specialOpeningHours.filter(
      (item) => item.date !== null
    );

    // A bookable without an id is created (`POST`), one with an id updated.
    if (!formData.id) {
      return ApiClient.post(`api/${t}/bookables`, formData);
    }
    return ApiClient.put(`api/${t}/bookables`, formData);
  },
  deleteBookable(bookableId) {
    return ApiClient.delete(
      `api/${store.getters["tenants/currentTenantId"]}/bookables/${bookableId}`
    );
  },
  duplicateBookable(bookableId) {
    return new Promise((resolve, reject) => {
      ApiClient.get(
        `api/${store.getters["tenants/currentTenantId"]}/bookables/${bookableId}`
      )
        .then((getBookingResponse) => {
          const bookable = Object.assign(new Object(), getBookingResponse.data);

          delete bookable.id;
          delete bookable._id;
          delete bookable.lockerDetails;

          bookable.title = `${bookable.title} (Kopie)`;

          if (bookable) {
            ApiClient.post(
              `api/${store.getters["tenants/currentTenantId"]}/bookables`,
              bookable
            )
              .then((putBookingResponse) => {
                resolve(putBookingResponse);
              })
              .catch((error) => {
                reject(error);
              });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getBookableTemplate(tenantId) {
    return ApiClient.get(`api/${tenantId}/bookables/_template`);
  },
  getRelatedOpeningHours(bookableId, tenantId) {
    const t = tenantId || store.getters["tenants/currentTenantId"];
    return ApiClient.get(`api/${t}/bookables/${bookableId}/openingHours`);
  },
  getBookableAvailability(bookableId, tenantId, startDate, endDate, amount) {
    return ApiClient.get(
      `api/${tenantId}/bookables/${bookableId}/availability?startDate=${startDate}&endDate=${endDate}&amount=${amount}`
    );
  },
  getBlockPeriods(bookableId, tenantId, startDate, endDate, amount = 1) {
    const t = tenantId || store.getters["tenants/currentTenantId"];
    return ApiClient.get(
      `api/${t}/bookables/${bookableId}/block-periods?startDate=${startDate}&endDate=${endDate}&amount=${amount}`
    );
  },
  async publicBookableCountCheck(tenantId) {
    const t = tenantId || store.getters["tenants/currentTenantId"];
    return (await ApiClient.get(`api/${t}/bookables/count/check`)).data;
  },
};
